import { FC } from "react";
import { ChatFileUnknownProps } from "./types";
import { Column, Row } from "../../../../../../components/containers";
import { useThemeStore } from "../../../../../../stores";
import { JustifyContent } from "../../../../../../components/containers/types";
import { Text } from "../../../../../../components/typography";
import { IconAnimation } from "../../../../../../components/animation";
import { DocumentIcon, DownloadIcon } from "../../../../../../assets/icons";
import { HOST_CHAT_FILES } from "../../../../../../api";
import { ChatStatus, Color } from "../../../../../../types";
import ProgressBar from "../../../../../../components/progress-bar";

const DEFAULT_CHAT_STATUS = ChatStatus.Sent;

const ChatFileUnknown: FC<ChatFileUnknownProps> = ({
  file,
  isMe,
  status,
  isSidePanel,
}) => {
  const theme = useThemeStore((s) => s.theme);

  const openFileInNewTab = () => {
    window.open(
      !file.local ? `${HOST_CHAT_FILES}/${file.filename}` : file.name
    );
  };

  const getTextBg = (): Color => {
    switch (status || DEFAULT_CHAT_STATUS) {
      case ChatStatus.Sent:
        return theme.chat.primary;
      case ChatStatus.Waiting:
        return theme.icon;
      case ChatStatus.Failed:
        return theme.alert;
      default:
        return "black";
    }
  };

  const getTextColor = (): Color => {
    switch (status || DEFAULT_CHAT_STATUS) {
      case ChatStatus.Sent:
        return theme.chat.textOnPrimary;
      case ChatStatus.Waiting:
        return "white";
      case ChatStatus.Failed:
        return theme.textOnAlert;
      default:
        return "black";
    }
  };

  return (
    <Column style={{ maxWidth: "100%" }} gap={8}>
      <Row
        reverse
        style={{ maxWidth: "calc(100% - 16px)", borderRadius: 15, padding: 8 }}
        background={isMe ? getTextBg() : theme.chat.secondary}
        justifyContent={JustifyContent.Between}
      >
        <Row
          gap={5}
          justifyContent={JustifyContent.End}
          style={{ maxWidth: "60%" }}
        >
          <Text
            textStyles={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              direction: "ltr",
            }}
            color={isMe ? getTextColor() : theme.chat.textOnSecondary}
          >
            {!file.local ? file.filename : file.realName}
          </Text>
          <DocumentIcon
            width={20}
            height={20}
            color={isMe ? theme.chat.textOnPrimary : theme.chat.textOnSecondary}
          />
        </Row>

        <IconAnimation
          Icon={DownloadIcon}
          onHoverColor={theme.primary}
          className="cursor-pointer"
          width={20}
          height={20}
          onClick={openFileInNewTab}
          color={isMe ? theme.chat.textOnPrimary : theme.chat.textOnSecondary}
        />
      </Row>

      <ProgressBar
        filename={file.local ? file.realName : ""}
        background={isSidePanel ? theme.overlay : theme.background}
      />
    </Column>
  );
};

export default ChatFileUnknown;
